import React, { Component, Fragment } from 'react';
import FocusTrap from 'focus-trap-react';
import onClickOutside from 'react-onclickoutside';
import PropTypes from 'prop-types';
import './styles.styl';

class PopUp extends Component {
  handleClick = (event, parent, menuItem) => {
    event.preventDefault();

    this.props.onSelect(event, parent, menuItem);
  };

  handleClickOutside = (event, turnOffPopUp) => {
    event.preventDefault();

    this.props.turnOffPopUp();
  };

  render() {
    return (
      <Fragment>
        <FocusTrap>
          <ul className="drag-item__popup">
            {this.props.menuItems.map(menuItem => {
              return (
                <li key={menuItem}>
                  <a
                    href=""
                    onClick={e =>
                      this.handleClick(e, this.props.parent, menuItem)
                    }
                  >
                    {menuItem}
                  </a>
                </li>
              );
            })}
          </ul>
        </FocusTrap>
      </Fragment>
    );
  }
}

PopUp.propTypes = {
  parent: PropTypes.any.isRequired,
  onSelect: PropTypes.func.isRequired,
  menuItems: PropTypes.arrayOf(PropTypes.string),
  turnOffPopUp: PropTypes.func.isRequired
};

export default onClickOutside(PopUp);



// WEBPACK FOOTER //
// ../core/src/components/PopUp/PopUp.js